<template>
  <GlobalWindow
    :title="`配置${field.label}数据`"
    width="1000px"
    :visible.sync="visible"
    :show-close="false"
    :with-back="false"
    :beforeClose="handleBeforeClose"
    confirmText="保存数据"
    cancelText="关闭"
    @confirm="handleConfirm"
  >
    <TableLayout class="field-data-table" :with-breadcrumb="false">
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <ul class="toolbar" v-permissions="['template:field:type:create', 'template:field:type:delete']">
          <li><el-button type="primary" @click="createDataRow" icon="el-icon-plus">新建</el-button></li>
          <li><el-button @click="deleteInBatch" icon="el-icon-delete">删除</el-button></li>
        </ul>
        <el-table
          :data="copyRows"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="value" label="数据值" min-width="150px">
            <template slot-scope="{ row }">
              <el-upload
                v-if="field.dataType === 'IMAGE'"
                action="/api/upload/image"
                :show-file-list="false"
                :drag="true"
                accept=".png,.jpeg,.jpg,.gif"
                :with-credentials="true"
                :on-success="getFieldUploadSuccessHandler(row)"
              >
                <p v-if="row.value == null || row.value === ''">拖拽图片文件到此或点击选择</p>
                <img v-else :src="row.value">
              </el-upload>
              <el-input v-else v-model="row.value" type="text"/>
            </template>
          </el-table-column>
          <el-table-column
            v-if="containPermissions(['template:field:type:update', 'template:field:type:delete'])"
            label="操作"
            min-width="120"
            fixed="right"
          >
            <template slot-scope="{row, $index}">
              <el-button type="text" @click="deleteByIndex($index)" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </TableLayout>
  </GlobalWindow>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import GlobalWindow from '../common/GlobalWindow'
import ColumnDetail from '../common/ColumnDetail'
export default {
  name: 'FieldDataTableWindow',
  extends: BaseTable,
  components: { ColumnDetail, GlobalWindow, TableLayout, Pagination },
  data () {
    return {
      visible: false,
      field: {
        required: true
      },
      copyRows: []
    }
  },
  methods: {
    // 打开
    open (target) {
      this.field = target
      this.copyRows = JSON.parse(JSON.stringify(this.field.rows))
      this.visible = true
    },
    // 确认
    handleConfirm () {
      if (this.copyRows.find(row => row.value.trim() === '') != null) {
        this.$tip.error('存在数据为空的行，请删除或补充后再保存')
        return
      }
      this.field.rows = this.copyRows
      this.visible = false
      this.$emit('save')
    },
    // 取消前处理
    handleBeforeClose () {
      if (JSON.stringify(this.copyRows) === JSON.stringify(this.field.rows)) {
        return Promise.resolve()
      }
      return this.$dialog.confirm(`确认放弃${this.field.label}字段的数据修改吗？`, '提示', {
        confirmButtonText: '确认放弃',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 创建
    createDataRow () {
      this.copyRows.push({
        frontId: 'row_' + Math.round(Math.random() * 10000),
        value: ''
      })
    },
    // 批量删除
    deleteInBatch () {
      this.copyRows = this.copyRows.filter(item => {
        return this.tableData.selectedRows.findIndex(row => row.frontId === item.frontId) === -1
      })
    },
    // 删除（点击行操作/删除时触发）
    deleteByIndex (index) {
      this.copyRows.splice(index, 1)
    },
    // 获取字段值上传成功处理函数
    getFieldUploadSuccessHandler (row) {
      return (response) => {
        if (!response.success) {
          this.$tip.error(response)
          return
        }
        row.value = response.data.accessUri
      }
    }
  }
}
</script>
<style scoped lang="scss">
.field-data-table {
  /deep/ .table-content {
    padding: 0;
    .table-wrap {
      padding: 0;
    }
  }
  /deep/ .el-table__body {
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
    .el-upload {
      width: 200px;
      height: 100px;
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
